import React from 'react';
import { useOfferCountdown } from '../hooks/useOfferCountdown';
type OfferCountdownProps = {
  tone?: 'dark' | 'lime';
  label?: string;
};
export function OfferCountdown({
  tone = 'dark',
  label = 'La oferta termina en'
}: OfferCountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useOfferCountdown();
  const units = [{
    value: hours,
    unit: 'Horas'
  }, {
    value: minutes,
    unit: 'Min'
  }, {
    value: seconds,
    unit: 'Seg'
  }];
  const isLime = tone === 'lime';
  return <div role="timer" aria-label={`${label}: ${hours} horas, ${minutes} minutos y ${seconds} segundos`} className="flex flex-col items-center" data-id="element-148" data-mp="1h77v2l3lntgw">
      <p className={`text-xs font-bold uppercase tracking-[0.2em] ${isLime ? 'text-ink/70' : 'text-alert'}`} data-id="element-149" data-mp="1l81nnrrzlwg4">{label}</p>
      <div className="mt-3 flex items-start gap-2" aria-hidden="true" data-id="element-150" data-mp="1q97hjsxdvpr8">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-151" data-mp="2wq2puojm6rqa" data-mpi={i}>
            {i > 0 && <span className={`pt-2 font-display text-3xl font-black ${isLime ? 'text-ink/40' : 'text-bone-dim'}`} data-id="element-152" data-mp="31m9vshc0g388">:</span>}
            <div className="flex flex-col items-center" data-id="element-153" data-mp="26oi17ghyp0z4">
              <span className={`min-w-[4.25rem] rounded-xl px-2 py-2 text-center font-display text-4xl font-black tabular-nums leading-none sm:text-5xl ${isLime ? 'bg-ink text-lime' : 'border border-ink-line bg-ink text-bone'}`} data-id="element-154" data-mp="21qzulwrf2xua">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-bold uppercase tracking-widest ${isLime ? 'text-ink/70' : 'text-bone-dim'}`} data-id="element-155" data-mp="1nsia07wt61gl">{u.unit}</span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}